import { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";

/** Every returns center supports these, so a center's settings never store them. */
export const ALWAYS_SUPPORTED_OUTCOMES: readonly InventoryItemOutcome[] = [
  InventoryItemOutcome.Restock,
  InventoryItemOutcome.Consolidate,
  InventoryItemOutcome.Fulfilled,
];
